import { render, staticRenderFns } from "./ResumoHabilitacaoCasamentoDetalhes.vue?vue&type=template&id=572ec770&"
import script from "./ResumoHabilitacaoCasamentoDetalhes.vue?vue&type=script&lang=js&"
export * from "./ResumoHabilitacaoCasamentoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ResumoHabilitacaoCasamentoDetalhes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports